<template>
  <div>
    <b-modal
      v-model="isError"
      :active="isError"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isError = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="isSuccess"
      :active="isSuccess"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isSuccess = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <thank-you
                  :paymentOrderID="paymentOrderID"
                  noOfPage="1"
                  :isPrint="isPrint"
                ></thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <v-container v-if="studentInfo" fluid>
      <div v-if="studentInfo">
        <v-card-component>
          <v-row key="1">
            <v-col cols="12" md="2" lg="2" xl="2" align="center">
              <v-img :src="tots_image" width="120"> </v-img>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Enquiry Code
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Student Name
                  </div>
                  <span
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.studentFirstName
                        ? studentInfo.studentFirstName + ' '
                        : ' '
                    "
                  >
                  </span>
                  <span
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.studentLastName
                        ? studentInfo.studentLastName
                        : ' '
                    "
                  >
                  </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Franchisee Name
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.franchisee.companyName
                        ? studentInfo.franchisee.companyName
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Academic Year
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.academicYear.academicYear
                        ? studentInfo.academicYear.academicYear
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Class</div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.class ? studentInfo.class : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row key="2">
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Parent / Guardian Name
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherName
                        ? studentInfo.fatherName
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  Parent / Guardian Mobile
                  <div class="grey--text text-subtitle-2 mb-1"></div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherMobile
                        ? studentInfo.fatherMobile
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Parent / Guardian Email
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="
                      studentInfo && studentInfo.fatherEmailID
                        ? studentInfo.fatherEmailID
                        : '-'
                    "
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Student Gender
                  </div>
                  <div
                    v-if="
                      studentInfo.gender === 'Female' ||
                      studentInfo.gender === 'FEMALE'
                    "
                    class="text-button mb-1"
                    v-text="
                      studentInfo &&
                      studentInfo.gender &&
                      studentInfo.gender === 'Female'
                        ? 'Girl'
                        : '-' ||
                          (studentInfo &&
                            studentInfo.gender &&
                            studentInfo.gender === 'FEMALE')
                        ? 'Girl'
                        : '-'
                    "
                  ></div>
                  <div
                    v-if="
                      studentInfo.gender === 'Male' ||
                      studentInfo.gender === 'MALE'
                    "
                    class="text-button mb-1"
                    v-text="
                      studentInfo &&
                      studentInfo.gender &&
                      studentInfo.gender === 'Male'
                        ? 'Boy'
                        : '-' ||
                          (studentInfo &&
                            studentInfo.gender &&
                            studentInfo.gender === 'MALE')
                        ? 'Boy'
                        : '-'
                    "
                  ></div>
                  <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">
                    Section / Division
                  </div>
                  <div
                    class="text-button mb-1"
                    v-text="studentInfo.section ? studentInfo.section : '-'"
                  ></div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-component>
        <v-row key="3">
          <v-col cols="12">
            <v-card-component>
              <v-row>
                <v-col cols="12" md="2" sm="4">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="text-subtitle-2 mb-1" style="color: #000">
                        Total Amount
                      </div>
                      <div
                        class="text-button mb-1"
                        v-text="
                          feeSummaryInfo.totalAmount
                            ? Number(feeSummaryInfo.totalAmount).toFixed(2)
                            : 0
                        "
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="2" sm="4">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="text-subtitle-2 mb-1" style="color: #000">
                        Amount Paid
                      </div>
                      <div
                        class="text-button mb-1"
                        v-text="
                          feeSummaryInfo.amountPaid
                            ? Number(feeSummaryInfo.amountPaid).toFixed(2)
                            : 0
                        "
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="2" sm="4">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="text-subtitle-2 mb-1" style="color: #000">
                        Remaining Amount
                      </div>
                      <div
                        class="text-button mb-1"
                        v-text="
                          feeSummaryInfo.remainingAmount
                            ? Number(feeSummaryInfo.remainingAmount).toFixed(2)
                            : 0
                        "
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="text-subtitle-2 mb-1" style="color: #000">
                        Enter Amount
                      </div>
                      <v-text-field
                        outlined
                        class="my-1"
                        v-model="remainingPaidAmount"
                        type="number"
                        dense
                        :error="payableAmountError"
                        :error-messages="payableAmountErrorMsg"
                        @input="validatePayableAmount"
                        :hint="`Minimum Amount to be paid is Rs. ${minimumPayableAmount}`"
                        persistent-hint
                        @keydown="handleExponential($event)"
                      />
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="2" sm="4">
                  <div class="d-flex justify-space-between caption">
                    <v-btn
                      class="mt-2"
                      success
                      icon-right="arrow-right-bold"
                      color="success"
                      @click="Pay"
                      :block="$vuetify.breakpoint.mobile"
                    >
                      Proceed to Pay (<span class="mdi mdi-currency-inr"></span
                      >{{ Number(remainingPaidAmount).toFixed(2) }})
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-component>
            <template>
              <template>
                <v-toolbar flat class="d-flex justify-center">
                  <v-toolbar-title
                    >Fee Structure (In Installments)</v-toolbar-title
                  >
                </v-toolbar>
              </template>
              <div v-if="$vuetify.breakpoint.smAndUp">
                <v-data-table
                  :headers="headers"
                  :items="feeTypeGroup"
                  :single-expand="true"
                  show-expand
                  hide-default-footer
                  class="elevation-1"
                  item-key="feeTypeName"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pb-4 pt-4">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">Installment Name</th>
                              <th class="text-center">Amount</th>
                              <th class="text-center" v-if="isConcession">
                                Concession Amount
                              </th>
                              <th class="text-center">Amount Due</th>

                              <!-- <th class="text-center" v-if="isGST && !isIGST">
                                  CGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && !isIGST">
                                  SGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && isIGST">
                                  IGST Amount
                                </th> -->

                              <th class="text-center">Amount To Pay</th>
                              <th class="text-center">Due Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="element in item.installments"
                              :key="element.id"
                            >
                              <td align="center" justify="center">
                                {{ element.name }}
                              </td>
                              <td align="center" justify="center">
                                {{ Number(element.amount).toFixed(2) }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="isConcession"
                              >
                                {{
                                  Number(element.amountConcession).toFixed(2)
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{ Number(element.amountDue).toFixed(2) }}
                              </td>
                              <!-- <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.cGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.sGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && isIGST">{{ Number(element.iGSTAmt).toFixed(2) }}</td> -->
                              <td align="center" justify="center">
                                {{ Number(element.payableAmt).toFixed(2) }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  new Date(element.dueDate).toLocaleDateString()
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </td>
                  </template>
                  <template v-slot:body.append="{ headers }">
                    <tr
                      :class="{
                        'v-data-table__mobile-table-row':
                          $vuetify.breakpoint.xs,
                        ' ': $vuetify.breakpoint.smAndUp
                      }"
                    >
                      <td
                        :class="{
                          'v-data-table__mobile-row': $vuetify.breakpoint.xs,
                          'text-center': $vuetify.breakpoint.smAndUp
                        }"
                        v-for="(header, i) in headers"
                        :key="i"
                      >
                        <div
                          :class="{
                            'v-data-table__mobile-row__cell':
                              $vuetify.breakpoint.xs,
                            ' ': $vuetify.breakpoint.smAndUp
                          }"
                          v-if="i === 0"
                          class="text-subtitle-2"
                        >
                          Totals
                        </div>
                        <div
                          :class="{
                            'v-data-table__mobile-row__cell':
                              $vuetify.breakpoint.xs,
                            ' ': $vuetify.breakpoint.smAndUp
                          }"
                          v-if="header.value == 'totalAmount'"
                          class="text-subtitle-2"
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalAmount.toFixed(2) }}
                        </div>
                        <div
                          :class="{
                            'v-data-table__mobile-row__cell':
                              $vuetify.breakpoint.xs,
                            ' ': $vuetify.breakpoint.smAndUp
                          }"
                          class="text-subtitle-2"
                          v-if="
                            isConcession && header.value == 'totalConcession'
                          "
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalConcession.toFixed(2) }}
                        </div>
                        <div
                          :class="{
                            'v-data-table__mobile-row__cell':
                              $vuetify.breakpoint.xs,
                            ' ': $vuetify.breakpoint.smAndUp
                          }"
                          v-if="header.value == 'totalAmountDue'"
                          class="text-subtitle-2"
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ totalAmountDue.toFixed(2) }}
                        </div>
                        <!-- <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && isIGST && header.value == 'totalIGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalIGST.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && !isIGST && header.value == 'totalCGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalCGST.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && !isIGST && header.value == 'totalSGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalSGST.toFixed(2) }}
                          </div> -->
                        <div
                          :class="{
                            'v-data-table__mobile-row__cell':
                              $vuetify.breakpoint.xs,
                            ' ': $vuetify.breakpoint.smAndUp
                          }"
                          v-if="header.value == 'totalAmountPayable'"
                          class="text-subtitle-2"
                        >
                          <span class="mdi mdi-currency-inr"></span
                          >{{ Number(totalAmountToPay).toFixed(2) }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <!-- Mobile view  -->
              <div v-else>
                <v-card-actions>
                  <v-card-title class="text-overline">DETAILS</v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" @click="modalOpen()" text outlined>
                    <v-icon left> mdi-information-variant</v-icon>
                  </v-btn>
                </v-card-actions>
                <div
                  v-for="(feeName, index) in feeTypeGroup"
                  :key="index"
                  class="text-subtitle-1 font-weight-light"
                >
                  <v-row class="ma-0" no-gutters>
                    <v-col cols="12" md="3">
                      <v-card-actions>
                        <span class="black--text">Fee Type :</span>

                        <v-row align="center" justify="end" class="ma-1">
                          <span>
                            {{ feeName.feeTypeName }}
                          </span>
                        </v-row>
                      </v-card-actions>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-card-actions>
                        <span class="black--text">Amount to pay :</span>
                        <v-row align="center" justify="end" class="ma-1">
                          <span
                            class="mdi mdi-currency-inr font-weight-bold black--text"
                            >{{ feeName.totalAmountPayable }}</span
                          >
                        </v-row>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </div>
                <v-divider class="my-0"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <v-card-actions>
                      <span class="text-h5"> Totals </span>
                      <v-row align="center" justify="end">
                        <div
                          v-for="(header, i) in feeTypeGroup.slice(0, 1)"
                          :key="i"
                          class="text-h5 mr-2"
                        >
                          <v-btn
                            success
                            icon-right="arrow-right-bold"
                            id="rzp-button1"
                            color="success"
                            @click="Pay"
                          >
                            Pay (<span class="mdi mdi-currency-inr"></span
                            >{{ Number(totalAmountToPay).toFixed(2) }})
                          </v-btn>
                        </div>
                      </v-row>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </div>
              <!-- INstallmets details Dialog -->
              <v-dialog
                v-model="dialogPop"
                max-width="1200"
                :active="dialogPop"
                persistent
              >
                <v-card>
                  <v-toolbar dark color="darkblue">
                    <v-toolbar-title>Installments</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn
                        icon
                        dark
                        @click="
                          () => {
                            dialogPop = false
                          }
                        "
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>

                  <v-stepper v-model="stepperPopUp">
                    <v-stepper-header class="stepper">
                      <div
                        v-for="(feeName, index) in feeTypeGroup"
                        :key="index"
                      >
                        <v-stepper-step :step="index + 1" editable>
                          {{ feeName.feeTypeName }}
                        </v-stepper-step>
                        <v-divider
                          v-if="index + 1 < feeName.length"
                        ></v-divider>
                      </div>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(feeName, index) in feeTypeGroup"
                        :key="index"
                        :step="index + 1"
                      >
                        <div v-show="$vuetify.breakpoint.smAndDown">
                          <v-card-title class="text-overline">{{
                            feeName.feeTypeName
                          }}</v-card-title>
                          <v-divider class="my-0"></v-divider>
                        </div>
                        <div>
                          <v-data-table
                            :headers="installmentHeaders"
                            :items="feeName.installments"
                            disable-sort
                            hide-default-footer
                            class="elevation-1"
                          >
                            <template v-slot:item.isChecked="{ item }">
                              <span>
                                <v-checkbox
                                  class="shrink mr-0 mt-0"
                                  readonly
                                  :value="true"
                                  v-model="item.isChecked"
                                  :disabled="item.isCompulsory"
                                  hide-details
                                >
                                </v-checkbox>
                              </span>
                            </template>
                            <template v-slot:item.name="{ item }">
                              <span>{{ item.name }} </span>
                            </template>
                            <template v-slot:item.amount="{ item }">
                              <span> {{ Number(item.amount).toFixed(2) }}</span>
                            </template>
                            <template v-slot:item.amountConcession="{ item }">
                              <span>
                                {{
                                  Number(item.amountConcession).toFixed(2)
                                }}</span
                              >
                            </template>
                            <template v-slot:item.dueDate="{ item }">
                              <span>
                                {{
                                  new Date(item.dueDate).toLocaleDateString()
                                }}
                              </span>
                            </template>
                            <template v-slot:item.amountDue="{ item }">
                              <span>
                                {{ Number(item.amountDue).toFixed(2) }}</span
                              >
                            </template>
                            <!-- <template v-slot:item.cGSTAmt="{item}">
                                <span> {{ Number(item.cGSTAmt).toFixed(2) }}</span>
                                </template>
                                <template v-slot:item.sGSTAmt="{item}">
                              <span> {{ Number(item.sGSTAmt).toFixed(2) }}</span>
                                </template>
                                <template v-slot:item.iGSTAmt="{item}">
                              <span> {{ Number(item.iGSTAmt).toFixed(2) }}</span>
                                </template> -->
                            <template v-slot:item.payableAmt="{ item }">
                              <span>
                                {{ Number(item.payableAmt).toFixed(2) }}</span
                              >
                            </template>
                          </v-data-table>
                        </div>
                        <v-card-actions v-if="$vuetify.breakpoint.smAndUp">
                          <v-row align="end" justify="end" class="ma-1">
                            <v-btn
                              color="primary"
                              @click="nextStep(index + 1)"
                              elevation="1"
                              absolute
                              top
                              right
                              fab
                            >
                              Next
                            </v-btn>
                          </v-row>
                        </v-card-actions>
                        <v-card-actions v-else>
                          <v-row align="end" justify="end" class="ma-1">
                            <v-btn
                              color="primary"
                              @click="nextStep(index + 1)"
                              elevation="1"
                              absolute
                              top
                              right
                              fab
                              small
                            >
                              <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                          </v-row>
                        </v-card-actions>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-card>
              </v-dialog>
            </template>
          </v-col>
        </v-row>
      </div>
      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
        {{ snackbarMsg || 'Welcome' }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!-- <div class="text-center">
        <v-dialog
          v-model="payNowDialog"
          width="600"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 justify-center">
              You need to pay minimum Rs. {{ minimumPayableAmount }}
            </v-card-title>
            <v-card-actions class="justify-center" :class="$vuetify.breakpoint.mobile ? 'py-4':'pt-5 pb-10'">
              <v-spacer></v-spacer>
              <v-row>
                <v-col class="text-center py-0" :class="$vuetify.breakpoint.mobile ? 'mb-2':''" cols="12" md="7" sm="7" xs="12">
                  <v-btn
                    color="primary"
                    @click="Pay"
                    :block="$vuetify.breakpoint.mobile"
                  >
                    Continue with entered amount
                  </v-btn>
                </v-col>
                <v-col class="text-center py-0" :class="$vuetify.breakpoint.mobile ? 'mb-2':''" cols="12" md="5" sm="5" xs="12">
                  <v-btn
                    color="success"
                    @click="handlePayNowButton(false)"
                    :block="$vuetify.breakpoint.mobile"
                  >
                    Pay minimum amount
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div> -->
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import ThankYou from '../../Fees/payment/thankYou'
import ErrorPage from '../../Fees/payment/error'
import VCardComponent from '@/components/template/VCardComponent.vue'

export default {
  name: 'PlanAssignInstallmentList',
  components: {
    ThankYou,
    ErrorPage,
    VCardComponent
  },
  props: ['referenceID'],
  data () {
    return {
      dialogPop: false,
      stepperPopUp: 1,
      isPrint: true,
      sendCaptureRespos: [],
      isRecipt: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      // installment header
      installmentHeaders: this.getInsallHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      checkedRows: [],
      isSuccess: false,
      isError: false,
      isOnlyApplicationFees: false,
      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      orderID: '',
      // Student info table
      studentHeader: [
        { text: 'Enquiry Code', value: 'enquiryCode', align: 'center' },
        { text: 'Student Name', value: 'studentFirstName', align: 'center' },
        {
          text: 'Franchisee Name',
          value: 'franchisee.companyName',
          align: 'center'
        },
        { text: 'Academic Year', value: 'academicYear', align: 'center' },
        { text: 'Class', value: 'class', align: 'center' },
        {
          text: 'Parent / Guardian Name',
          value: 'fatherName',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Mobile',
          value: 'fatherMobile',
          align: 'center'
        },
        {
          text: 'Parent / Guardian Email',
          value: 'fatherEmailID',
          align: 'center'
        },
        { text: 'Student Gender', value: 'gender', align: 'center' },
        { text: 'Section / Division', value: 'section', align: 'center' }
      ],
      paymentOrderID: '',
      feeSummaryInfo: {
        totalAmount: '',
        amountPaid: '',
        remainingAmount: ''
      },
      remainingPaidAmount: 0,
      maximumPayable: 0,
      payNowDialog: false,
      compulsoryPayableAmount: 0,
      minimumPayableAmount: 0,
      payableAmountError: false,
      payableAmountErrorMsg: '',
      checkMinimumBtn: false
    }
  },
  beforeCreate () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `${constants.RAZORPAY.JS}`)
    document.head.appendChild(recaptchaScript)
  },
  async created () {
    window.addEventListener('beforeunload', this.beforePageDestroyed)
    window.addEventListener('unload', this.beforePageDestroyed)
    await this.getAllInfo()
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforePageDestroyed)
    window.removeEventListener('unload', this.beforePageDestroyed)
  },
  methods: {
    // Added function for diaglog button
    nextStep (n) {
      if (n === this.feeTypeGroup.length) {
        this.stepperPopUp = 1
      } else {
        this.stepperPopUp = n + 1
      }
    },
    beforePageDestroyed: async function (e) {
      console.log('beforePageDestroyedPayment ONINE')
      if (this.orderID) {
        e.returnValue = ''
        await this.reject().catch((err) => {
          console.log(err)
        })
        e.preventDefault()
        e.returnValue = false // Seems require this for Chrome
      }
    },

    reject: async function () {
      console.log(this.orderID)
      if (!this.orderID) {
        return
      }
      try {
        this.isLoading = true
        await http.patch(
          `${constants.API_URL}/api/payments/online/reject/order`,
          { orderID: this.orderID }
        )
        this.isLoading = false

        this.orderID = ''

        this.$dialog.info({
          text: `Online Payment Rejected !!`,
          title: 'Rejected'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    closePopUp () {
      console.log('triggered!!')
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    changeInstallments: function (type, item) {
      if (type === 'plus') {
        if (item.position >= item.maxPosition) {
          item.position = item.maxPosition
          this.openSnackbar('All due installments are selected.')
        } else {
          item.position = item.position + 1
        }
      } else {
        if (item.position <= item.minPosition) {
          item.position = item.minPosition
          this.openSnackbar('Minimum due till dates installments are selected.')
        } else {
          item.position = item.position - 1
        }
      }
      this.calculatePayAmount()
    },
    // installments
    getInsallHeaders () {
      let header = [
        // { text: 'Pay Now', value: 'isChecked' },
        { text: 'Installments', value: 'name', align: 'center' },
        { text: 'Amount', value: 'amount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({
          text: 'Concession Amount',
          value: 'amountConcession',
          align: 'center'
        })
      }
      header.push({ text: 'Amount Due', value: 'amountDue', align: 'center' })

      // if (this.isGST) {
      //   if (this.isIGST) {
      //     header.push({ text: 'IGST Amount', value: 'iGSTAmt', align: 'center' })
      //   } else {
      //     header.push({ text: 'CGST Amount', value: 'cGSTAmt', align: 'center' })
      //     header.push({ text: 'SGST Amount', value: 'sGSTAmt', align: 'center' })
      //   }
      // }
      header.push({
        text: 'Amount To Pay',
        value: 'payableAmt',
        align: 'center'
      })
      header.push({ text: 'Due Date', value: 'dueDate', align: 'center' })

      return header
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        // { text: 'Installments', value: 'position', align: 'center', width: 150 },
        { text: 'Amount', value: 'totalAmount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({
          text: 'Concession Amount',
          value: 'totalConcession',
          align: 'center'
        })
      }
      header.push({
        text: 'Amount Due',
        value: 'totalAmountDue',
        align: 'center'
      })

      // if (this.isGST) {
      //   if (this.isIGST) {
      //     header.push({ text: 'IGST', value: 'totalIGST', align: 'center' })
      //   } else {
      //     header.push({ text: 'CGST', value: 'totalCGST', align: 'center' })
      //     header.push({ text: 'SGST', value: 'totalSGST', align: 'center' })
      //   }
      // }
      header.push({
        text: 'Amount To Pay',
        value: 'totalAmountPayable',
        align: 'center'
      })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalAmountDue = 0
      this.totalAmountPaid = 0
      this.totalConcession = 0
      this.totalAmountToPay = 0
      this.totalIGST = 0
      this.totalCGST = 0
      this.totalSGST = 0
      this.checkedRows = []
      _.forEach(this.feeTypeGroup, (item) => {
        item.totalAmount = 0
        item.totalAmountDue = 0
        item.totalAmountPaid = 0
        item.totalConcession = 0
        item.totalAmountPayable = 0
        item.totalCGST = 0
        item.totalSGST = 0
        item.totalIGST = 0
        _.forEach(item.installments, (itemChild, indexChild) => {
          // if (item.position > indexChild) {
          itemChild.isChecked = true
          item.totalAmount = this.addTwoNumber(
            item.totalAmount,
            itemChild.amount
          )
          item.totalAmountDue = this.addTwoNumber(
            item.totalAmountDue,
            itemChild.amountDue
          )
          item.totalConcession = this.addTwoNumber(
            item.totalConcession,
            itemChild.amountConcession
          )
          item.totalCGST = this.addTwoNumber(item.totalCGST, itemChild.cGSTAmt)
          item.totalSGST = this.addTwoNumber(item.totalSGST, itemChild.sGSTAmt)
          item.totalIGST = this.addTwoNumber(item.totalIGST, itemChild.iGSTAmt)
          item.totalAmountPayable = this.addTwoNumber(
            item.totalAmountPayable,
            itemChild.payableAmt
          )
          this.checkedRows.push(itemChild.id)
          // } else {
          //   itemChild.isChecked = false
          // }
          item.totalAmountPaid = this.addTwoNumber(
            item.totalAmountPaid,
            itemChild.amountPaid
          )
        })
        this.totalAmount = this.addTwoNumber(item.totalAmount, this.totalAmount)
        this.totalAmountPaid = this.addTwoNumber(
          item.totalAmountPaid,
          this.totalAmountPaid
        )
        this.totalAmountDue = this.addTwoNumber(
          item.totalAmountDue,
          this.totalAmountDue
        )
        this.totalConcession = this.addTwoNumber(
          item.totalConcession,
          this.totalConcession
        )
        this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
        this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
        this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
        this.totalAmountToPay = this.addTwoNumber(
          item.totalAmountPayable,
          this.totalAmountToPay
        )
      })
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    captureResponse: async function () {
      try {
        console.log('Captured ', this.orderID)
        this.orderID = ''
        this.loadingComponent = this.$buefy.loading.open()

        const response = await http.post(
          `${constants.API_URL}/api/payments/order`,
          {
            referenceID: this.referenceID,
            assignFeeInstallmentID: this.checkedRows,
            amount: this.remainingPaidAmount,
            isPortal: true
          }
        )
        this.orderID = response.data.orderID

        return response
        // this.Pay(event, response.data)
      } catch (e) {
        await this.reject()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    validatePayableAmount: function () {
      this.payableAmountError = false
      this.payableAmountErrorMsg = ''
      if (this.remainingPaidAmount <= 0) {
        this.payableAmountError = true
        this.payableAmountErrorMsg = `You need to pay minimum ${this.minimumPayableAmount} amount.`
      }
      if (this.remainingPaidAmount > this.maximumPayable) {
        this.payableAmountError = true
        this.payableAmountErrorMsg = `You need to pay maximum ${this.maximumPayable} amount.`
      }
      return true
    },
    Pay: async function (event) {
      try {
        if (this.remainingPaidAmount > this.maximumPayable) {
          const errorMessage = `You need to pay maximum ${this.maximumPayable} amount.`
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.payNowDialog = false
        const resultantObj = await this.captureResponse()
        let self = this
        console.log(resultantObj.data)
        var options = {
          key: `${constants.RAZORPAY.RAZOR_KEY}`, // Enter the Key ID generated from the Dashboard
          amount: this.checkMinimumBtn
            ? this.minimumPayableAmount
            : this.remainingPaidAmount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: 'INR',
          name: 'Firstcry Intellitots',
          description: `${constants.RAZORPAY.FEE_TYPE.ADMISSION_FEE}`,
          image: `${constants.RAZORPAY.TOTS_IMAGE}`,
          order_id: resultantObj.data.orderID, // This is a sample Order   ID. Pass the `id` obtained in the response of Step 1
          handler: async function (response) {
            await self.postCapture(response.razorpay_payment_id)
          },
          modal: {
            ondismiss: async function () {
              await self.reject()
            }
          },
          prefill: {
            name: self.studentInfo.fatherName,

            email: self.studentInfo.fatherEmailID || 'SXXXXXXXX@gmail.com',
            contact: self.studentInfo.fatherMobile || '9999999999'
          },
          notes: {
            address: 'Razorpay Corporate Office'
          },
          theme: {
            color: `${constants.RAZORPAY.COLOR}`
          }
        }

        let rzp = new window.Razorpay(options)

        rzp.on('payment.failed', async function (response) {
          await self.reject()
          if (confirm(response.error.reason)) {
            location.reload()
          } else {
            location.reload()
          }
        })

        rzp.open()
        event.preventDefault()
      } catch (e) {
        await self.reject()
        self.isError = true

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
      }
    },
    postCapture: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.sendCaptureRespos = await http.post(
          `${constants.API_URL}/api/payments/capture`,
          { paymentID: key }
        )
        // this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)
        this.paymentOrderID = this.sendCaptureRespos.data.paymentOrderData.id
        this.sendCaptureRespos = await http.get(
          `${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`
        )
        this.orderID = ''
        this.isSuccess = true
        // this.$router.push({ name: 'invoice' })
      } catch (e) {
        this.isError = true
        this.orderID = ''

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(
          `${constants.API_URL}/api/admission-fee-payment/installments/${this.referenceID}/ONLINE`
        )
        this.studentInfo = response.data.studentInfo
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup.map((item) => {
          if (item.invoiceFeeName === constants.feeType.Tuition_Fees) {
            if (item.position === 0) {
              // Atleast one instalment should be selected
              let pos = item.position + 1
              if (pos <= item.maxPosition) {
                item.position = pos
              }
            }
          }
          return item
        })
        this.isOnlyApplicationFees = this.feeTypeGroup.length === 1
        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.calculatePayAmount()
        this.headers = this.getHeaders()
        this.installmentHeaders = this.getInsallHeaders()
        // Fee Summary Data
        this.feeSummaryInfo.totalAmount = this.totalAmount
        this.feeSummaryInfo.amountPaid = this.totalAmountPaid
        this.feeSummaryInfo.remainingAmount = this.totalAmountDue
        this.remainingPaidAmount = this.totalAmountDue
        this.maximumPayable = this.totalAmountDue
        let { compulsoryPayableAmount, minimumPayableAmount } =
          response.data.validationAmount
        this.compulsoryPayableAmount = compulsoryPayableAmount
        this.minimumPayableAmount = minimumPayableAmount
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.isError = true
      } finally {
        this.loadingComponent.close()
      }
    },
    // Installemnt Details Pop Dialog
    modalOpen () {
      this.dialogPop = true
    },
    // handlePayNowButton (flag) {
    //   this.checkMinimumBtn = false
    //   if (flag) {
    //     if (this.remainingPaidAmount < this.compulsoryPayableAmount) {
    //       this.payableAmountError = true
    //       this.payableAmountErrorMsg = `You have to pay compulsory amount of ${this.compulsoryPayableAmount} for admission confirmation.`
    //     } else {
    //       this.stepper = 2
    //     }
    //   } else {
    //     this.checkMinimumBtn = true
    //     this.stepper = 2
    //   }
    //   this.payNowDialog = false
    // },
    handleExponential: function (evt) {
      if (
        evt.which !== 8 &&
        evt.which !== 0 &&
        evt.which !== 190 &&
        evt.which !== 17 &&
        evt.which !== 65 &&
        evt.which !== 110 &&
        (evt.which < 48 || evt.which > 57) &&
        (evt.which > 106 || evt.which < 96)
      ) {
        evt.preventDefault()
      }
    }
  }
}
</script>
<style lang="css">
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
/* .stepper {
    overflow: auto;
    white-space: nowrap;
} */
/* .v-stepper__header {
  box-shadow: none;

} */
.v-stepper__step {
  padding: 2px !important;
  padding-top: 24px !important;
}

.green-text {
  cursor: pointer;
  color: #4caf50 !important;
  font-weight: 500;
}

.green-holder {
  border: solid 3px #a5c347;
  border-radius: 50%;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.green-holder:hover {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.red-holder {
  border: solid 3px #f44336;
  border-radius: 50%;
}

.red-holder:hover {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.red-text {
  cursor: pointer;
  color: #f44336 !important;
  font-weight: 500;
}

.v-input__slot:before {
  width: 60% !important;
}

.v-input__slot:after {
  width: 60% !important;
}
</style>
